import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import type { WindowEventsEmitter } from './modules/shared/events/window.events';

/**
 * Relays window click, resize and scroll events into WindowEventsEmitter. Every "close on outside click / on
 * selection" in the app listens to that emitter (ngDropdown, tooltips, popups, combo boxes, date pickers), so
 * nothing closes until this relay is running.
 */
export function relayWindowEvents(emitter: WindowEventsEmitter, target: Window = window): Subscription {
  const subscription = new Subscription();

  subscription.add(fromEvent(target, 'click').subscribe((e) => emitter.broadcastWindowClickEventTriggered(e)));
  subscription.add(
    fromEvent(target, 'resize')
      .pipe(debounceTime(100))
      .subscribe((e) => emitter.broadcastWindowResizeEventTriggered(e)),
  );
  // Capture phase: scroll does not bubble, and inner containers scroll far more often than the window itself.
  subscription.add(
    fromEvent(target, 'scroll', { capture: true }).subscribe((e) => emitter.broadcastWindowScrollEventTriggered(e)),
  );

  return subscription;
}
